module.exports = __webpack_public_path__ + "media/audios/kid/lesson_9/audio58-e4a609f1a6deb7849cee46e66e94bb18.m4a";